import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import disableInFastboot from '@triptyk/ember-utils/decorators/disable-in-fastboot';

interface FormationPartsProgramComponentArgs {}

export interface ProgramItem {
  name: string;
  children: ProgramItem[];
}

export default class FormationPartsProgramComponent extends Component<FormationPartsProgramComponentArgs> {
  @tracked declare program: ProgramItem[];
  @tracked declare beforeProgram: HTMLElement | undefined;
  @tracked declare afterProgram: HTMLElement | undefined;

  @action
  @disableInFastboot
  generateProgram(element: HTMLElement) {
    const list = element.querySelector('ul');
    if (!list) return;

    this.beforeProgram = this.extractContentBeforeList(element);
    this.afterProgram = this.extractContentAfterList(element, list);
    this.program = this.convertListToTable(list);
  }

  @disableInFastboot
  convertListToTable(list: HTMLElement | null): ProgramItem[] {
    if (!list) return [];
    const elements = list.querySelectorAll(':scope > li');
    return [...elements].map((element) => ({
      name: element.firstChild!.textContent!.trim(),
      children: this.convertListToTable(element.querySelector('ul')),
    }));
  }

  @disableInFastboot
  extractContentBeforeList(element: HTMLElement): HTMLElement | undefined {
    let sibling = element.firstElementChild;
    if (sibling?.tagName === 'UL') return undefined;
    const clone = sibling!.cloneNode(true) as HTMLElement;
    return clone;
  }

  extractContentAfterList(
    element: HTMLElement,
    list: HTMLElement
  ): HTMLElement | undefined {
    if (!list) {
      return;
    }
    let sibling = list.nextElementSibling;
    if (!sibling) {
      return;
    }
    const clone = sibling.cloneNode(true) as HTMLElement;
    return clone;
  }
}
